import React, { useState } from "react";
import accountApi from "../../api/accountApi";
import ClientForm from "./ClientForm";


const ClientManagement = () => {
    const [view, setView] = useState("list");
    const [selectedClient, setSelectedClient] = useState(null);
    const [clients, setClients] = useState([]);

    const handleAddClient = () => {
        setSelectedClient(null);
        setView("add");
    };

    const handleEditClient = (client) => {
        setSelectedClient(client);
        setView("edit");
    };

    const handleSaveClient = async (clientData) => {
        try {
            const token = localStorage.getItem("authToken");

            if (selectedClient) {
                const response = await accountApi.updateAccount(selectedClient.id, clientData, token);
                setClients(prev => prev.map(c => c.id === selectedClient.id ? response.data : c));
            } else {
                const response = await accountApi.createAccount(clientData, token);
                setClients(prev => [...prev, response.data]);
            }

            setView("list");
        } catch (error) {
            console.error("Error saving client:", error);
            alert("Failed to save client. Please try again.");
        }
    };

    const handleCancel = () => {
        setView("list");
    };

    return (
        <div>
            {view === "list" && (
                <div>
                    <button onClick={handleAddClient}>Add New Client</button>

                </div>
            )}

            {(view === "add" || view === "edit") && (
                <ClientForm
                    clientData={selectedClient}
                    onSave={handleSaveClient}
                    onCancel={handleCancel}
                    isEditing={view === "edit"}
                />
            )}
        </div>
    );
};

export default ClientManagement;